import React, { Component } from 'react';
import { ThemeContext } from '../../../context/theme.context';
import '../style.css';
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  StackingColumnSeries,
  Tooltip,
  DataLabel,
  LineSeries,
} from '@syncfusion/ej2-react-charts';
import { getTradePersonGraph } from '../../../services/KPIsServices/KPIsServices';
import Scheduler from '../../../components/GlobalScheduler';
import Loader from 'react-spinners/PulseLoader';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { GlobalDropDown } from '../../../components/GlobalDropDown';
import { getTeams } from '../../../services/tradeperson/team';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import { setfilterConfirmation } from '../../../redux/search.slice';
import { BiRefresh } from 'react-icons/bi';
interface IProps {
  defaultAssignments: number[];
  filterConfirmation: boolean;
  storeTeam: string[];
  storeTrades: string[];
  storeAssign: string[];
  storeTradeAssignmentIds: string[];
  setfilterConfirmation: (value: boolean) => void;
}
interface IState {
  showSpinner: boolean;
  graph1Data: Array<any>;
  graph2Data: Array<any>;
  graph3Data: Array<any>;
}
class TradepersonCapacity extends Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private graph1Teams: Array<any> = [];
  private graph1Tickets: Array<any> = [];
  private graph2Teams: Array<any> = [];
  private graph2Tickets: Array<any> = [];
  private graph3Teams: Array<any> = [];
  private graph3Tickets: Array<any> = [];
  private grap1Obj: ChartComponent;
  private grap2Obj: ChartComponent;
  private grap3Obj: ChartComponent;
  private selectedTeamForGraph: '' = '';
  private teamsdata: [] = [];

  constructor(props: IProps) {
    super(props);
    this.state = {
      showSpinner: false,
      graph1Data: [],
      graph2Data: [],
      graph3Data: [],
    };
    this.grap1Obj = new ChartComponent(props);
    this.grap2Obj = new ChartComponent(props);
    this.grap3Obj = new ChartComponent(props);
  }
  private isRendering: boolean = false;
  private baseColor = 'e36927';
  private colors = [
    '#7a42db',
    '#db6b16',
    '#db3016',
    '#30ed13',
    '#696969',
    '#22799c',
    '#db6b16',
    '#81a391',
    '#8216db',
    '#8e18c9',
    '#f2eeb8',
    '#00b6ff',
    '#2a1140',
    '#d736e3',
    '#d1c40f',
    '#a971ad',
    '#6c5f73',
    '#e6e3e8',
    '#f097b0',
    '#73eb89',
  ];
  generateColor(color: string, index: number) {
    return this.colors[index];
  }
  componentDidMount() {
    this.isRendering = true;
    this.getTradePersonGraph(Scheduler.AllFilterDAta);
    this.getTeamsData();
  }
  componentWillUnmount(): void {
    this.isRendering = false;
  }
  async getTeamsData() {
    let data = (await getTeams()).data;
    data.unshift({ team_code: '' });
    this.teamsdata = data;
  }
  async getTradePersonGraph(query: string, confirmation?: boolean) {
    this.graph1Teams = [];
    this.graph2Teams = [];
    this.graph3Teams = [];
    this.graph1Tickets = [];
    this.graph2Tickets = [];
    this.graph3Tickets = [];
    await getTradePersonGraph(query)
      .then((el) => {
        this.designData1(el.data.dataG1, this.graph1Tickets, this.graph1Teams);
        this.designData2(el.data.dataG2, this.graph2Tickets, this.graph2Teams);
        this.designData3(el.data.dataG3, this.graph3Tickets, this.graph3Teams);
        // if (this.selectedTeamForGraph) {
        //   newlist = this.graph3Teams.filter(
        //     (item) => item.team_code === this.selectedTeamForGraph
        //   );
        // }
      })
      .catch((e) => {
        console.log(e);
      });
    let newlist = [];
    if (confirmation) {
      const mergedList = Array.from(
        new Set([
          ...this.props.storeTeam,
          ...this.props.storeAssign,
          ...this.props.storeTradeAssignmentIds,
        ])
      );
      console.log(
        'this.props.defaultAssignments',
        this.props.defaultAssignments
      );
      console.log('this.graph3Teams', this.graph3Teams);

      if (mergedList.length > 0) {
        newlist = this.graph3Teams.filter((item) =>
          mergedList.includes(item.assignmentId.toString())
        );
      }
    }
    if (this.props.defaultAssignments.length > 0) {
      this.props.defaultAssignments.map(
        (eachAssignmentid: number, index: number) => {
          this.graph3Teams.map((eachData: { assignmentId: number }) => {
            if (eachData.assignmentId === eachAssignmentid) {
              newlist.push(eachData);
            }
          });
        }
      );
    }
    if (newlist.length == 0) {
      newlist = this.graph3Teams;
    }

    this.setState({
      graph1Data: this.graph1Teams,
      graph2Data: this.graph2Teams,
      graph3Data: newlist,
    });
  }
  designData1(data: Array<any>, tickets: Array<any>, output: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      data[index].trade_code =
        el.trade_code === '' ? 'NO TRADE' : el.trade_code;
      data[index].team_code = el.team_code === '' ? 'NO TEAM' : el.team_code;
      const foundIndex = tickets.findIndex((elin) => {
        return (
          (elin.value === el.trade_code && elin.type === el.type) ||
          (elin.value === 'Exception' && el.type === 'Exception')
        );
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        if (el.type === 'Exception') {
          tickets.push({
            y: `y${counter}`,
            value: el.type,
            color: el.type === 'Exception' ? '#789395' : el.color,
            type: el.type,
          });
        } else {
          tickets.push({
            y: `y${counter}`,
            value: el.trade_code,
            color: this.generateColor(this.baseColor, counter),
            type: el.type,
          });
        }
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = output.findIndex((elin) => {
        return elin.team_code === element.team_code;
      });
      var paramName: any = [];
      if (element.type === 'Shift') {
        paramName = tickets.filter((el) => el.value === element.trade_code);
      } else {
        paramName = tickets.filter((el) => el.value === 'Exception');
      }
      if (foundIndex != -1) {
        output[foundIndex][paramName[0]?.y] = element.Y;
      } else {
        output.push({
          trade_code: element.trade_code,
          team_code: element.team_code,
          [paramName[0]?.y]: element.Y,
        });
      }
    });
  }
  designData2(data: Array<any>, tickets: Array<any>, output: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      data[index].trade_code =
        el.trade_code === '' ? 'NO TRADE' : el.trade_code;
      data[index].dayName = el.dayName === '' ? 'NO TEAM' : el.dayName;
      const foundIndex = tickets.findIndex((elin) => {
        return (
          (elin.value === el.trade_code && elin.type === el.type) ||
          (elin.value === 'Exception' && el.type === 'Exception')
        );
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        if (el.type === 'Exception') {
          tickets.push({
            y: `y${counter}`,
            value: el.type,
            color: el.type === 'Exception' ? '#789395' : el.color,
            type: el.type,
          });
        } else {
          tickets.push({
            y: `y${counter}`,
            value: el.trade_code,
            color: this.generateColor(this.baseColor, counter),
            type: el.type,
          });
        }
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = output.findIndex((elin) => {
        return elin.dayName === element.dayName;
      });
      var paramName: any = [];
      if (element.type === 'Shift') {
        paramName = tickets.filter((el) => el.value === element.trade_code);
      } else {
        paramName = tickets.filter((el) => el.value === 'Exception');
      }
      if (foundIndex != -1) {
        output[foundIndex][paramName[0]?.y] = element.Y;
      } else {
        output.push({
          trade_code: element.trade_code,
          dayName: element.dayName,
          [paramName[0]?.y]: element.Y,
        });
      }
    });
  }
  designData3(data: Array<any>, tickets: Array<any>, output: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      const foundIndex = tickets.findIndex((elin) => {
        return elin.value === el.element_alias;
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        tickets.push({
          y: `y${counter}`,
          value: el.element_alias,
          color: el.shift_color,
          type: el.type,
        });
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = output.findIndex((elin) => {
        return elin.assignmentId === element.assignmentid;
      });
      const paramName = tickets.filter(
        (el) => el.value === element.element_alias
      );
      if (foundIndex != -1) {
        output[foundIndex][paramName[0]?.y] =element?.Y ? Math.abs(element?.Y / 60).toFixed(
          2
        ): (0).toFixed(2);
      } else {
        output.push({
          element_alias: element.element_alias,
          assignmentName: element.name,
          [paramName[0]?.y]:element?.Y ? Math.abs(element?.Y / 60).toFixed(2): (0).toFixed(2),
          assignmentId: element.assignmentid,
          team_code: element.team_code,
        });
      }
    });
  }
  generateInitialFilter = () => {
    let date = new Date();
    const startDate = date.getMonth() + 1 + '/' + 1 + '/' + date.getFullYear();
    const endDate =
      date.getMonth() +
      1 +
      '/' +
      new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate() +
      '/' +
      date.getFullYear();
    var alias = '';
    alias = alias.replace(/.$/, '');
    const asignments: any = [];
    return `'${startDate}'$'${endDate}'$${asignments}$${alias}`;
  };
  async componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ) {
    if (
      this.props.filterConfirmation == true &&
      !prevProps.filterConfirmation
    ) {
      await this.getTradePersonGraph(Scheduler.AllFilterDAta, true);
      this.props.setfilterConfirmation(false);
    }

    if (prevProps.defaultAssignments !== this.props.defaultAssignments) {
      this.getTradePersonGraph(Scheduler.AllFilterDAta, true);
    }
    if (this.state != prevState) {
      return;
    }
    // if (this.context.isDataChangeKpiTradePerson) {
    //   this.isRendering = true;

    //   this.getTradePersonGraph(Scheduler.AllFilterDAta);
    //   this.context.setDataChangeKpiTradePerson(false);
    // }
  }

  render() {
    return (
      <>
        {this.state.showSpinner ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '300px',
            }}
          >
            <Loader color='#A020F0' />
          </div>
        ) : (
          <div className='main-chart-content'>
            <BiRefresh
              size={23}
              onClick={async () => {
                this.setState({ showSpinner: true });
                await this.getTradePersonGraph(Scheduler.AllFilterDAta);
                this.setState({ showSpinner: false });
              }}
            />
            <div className='chart1' style={{ width: '33%' }}>
              <div className='left-component-first'>
                <span>
                  <b># of Tradeperson</b>
                </span>
              </div>
              <div className='left-component-three'>
                <ChartComponent
                  id='assigncharts'
                  style={{ textAlign: 'center' }}
                  ref={(el) => {
                    this.grap1Obj = el as ChartComponent;
                  }}
                  primaryXAxis={{
                    majorGridLines: { width: 0 },
                    minorGridLines: { width: 0 },
                    majorTickLines: { width: 0 },
                    minorTickLines: { width: 0 },
                    interval: 1,
                    lineStyle: { width: 0 },
                    labelIntersectAction: 'Rotate45',
                    valueType: 'Category',
                    labelStyle: {
                      size: '8px',
                    },
                  }}
                  primaryYAxis={{
                    lineStyle: { width: 0 },
                    minimum: 0,

                    majorTickLines: { width: 1 },
                    majorGridLines: { width: 0 },
                    minorGridLines: { width: 1 },
                    minorTickLines: { width: 1 },
                    labelFormat: '{value}',
                    labelStyle: {
                      size: '8px',
                    },
                  }}
                  width={'100%'}
                  chartArea={{ border: { width: 0 } }}
                  tooltip={{ enable: true }}
                  height={'190px'}
                  background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
                  legendSettings={{
                    textStyle: {
                      color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                      size: '8px',
                    },
                    position: 'Top',
                  }}
                >
                  <Inject
                    services={[
                      StackingColumnSeries,
                      Category,
                      Legend,
                      Tooltip,
                      LineSeries,
                    ]}
                  />
                  <SeriesCollectionDirective>
                    {this.graph1Tickets.map((el: any, index: number) => {
                      if (el.type === 'Exception') {
                        return (
                          <SeriesDirective
                            zOrder={1000000}
                            key={Math.random()}
                            dataSource={this.state.graph1Data}
                            xName='team_code'
                            yName={`y${index}`}
                            animation={{ enable: true }}
                            name={el.value}
                            type='Line'
                            fill={el.color}
                            marker={{ visible: true, width: 10, height: 10 }}
                          ></SeriesDirective>
                        );
                      } else {
                        return (
                          <SeriesDirective
                            key={Math.random()}
                            dataSource={this.state.graph1Data}
                            xName='team_code'
                            yName={`y${index}`}
                            name={el.value}
                            type='StackingColumn'
                            fill={el.color}
                            cornerRadius={{
                              topLeft: 0,
                              topRight: 0,
                            }}
                          ></SeriesDirective>
                        );
                      }
                    })}
                  </SeriesCollectionDirective>
                </ChartComponent>
              </div>
              <div className='left-component-fourr'></div>
            </div>
            <div className='chart2' style={{ width: '33%' }}>
              <div className='blanc-text'>
                <span>
                  <b># of Tradespeople</b>
                </span>
              </div>

              <ChartComponent
                id='assingcharts2'
                style={{ textAlign: 'center' }}
                ref={(el) => {
                  this.grap2Obj = el as ChartComponent;
                }}
                primaryXAxis={{
                  valueType: 'Category',
                  labelIntersectAction: 'Rotate45',
                  majorGridLines: { width: 0 },
                  minorGridLines: { width: 0 },
                  majorTickLines: { width: 0 },
                  minorTickLines: { width: 0 },
                  labelStyle: {
                    size: '8px',
                  },
                }}
                primaryYAxis={{
                  rangePadding: 'None',
                  interval: 20,
                  majorTickLines: { width: 1 },
                  majorGridLines: { width: 0 },
                  minorGridLines: { width: 1 },
                  minorTickLines: { width: 1 },
                  labelStyle: {
                    size: '8px',
                  },
                  lineStyle: {
                    width: 0,
                  },
                }}
                width={'100%'}
                chartArea={{ border: { width: 0 } }}
                tooltip={{
                  enable: true,
                }}
                height={'190px'}
                background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
                legendSettings={{
                  textStyle: {
                    color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                    size: '8px',
                  },
                  position: 'Top',
                }}
              >
                <Inject
                  services={[
                    StackingColumnSeries,
                    Legend,
                    Tooltip,
                    DataLabel,
                    Category,
                    LineSeries,
                  ]}
                />
                <SeriesCollectionDirective>
                  {this.graph2Tickets.map((el: any, index: number) => {
                    if (el.type === 'Exception') {
                      return (
                        <SeriesDirective
                          zOrder={1000000}
                          key={Math.random()}
                          dataSource={this.state.graph2Data}
                          xName='dayName'
                          yName={`y${index}`}
                          animation={{ enable: true }}
                          name={el.value}
                          type='Line'
                          fill={el.color}
                          marker={{ visible: true, width: 10, height: 10 }}
                        ></SeriesDirective>
                      );
                    } else {
                      return (
                        <SeriesDirective
                          key={Math.random()}
                          dataSource={this.state.graph2Data}
                          xName='dayName'
                          yName={`y${index}`}
                          name={el.value}
                          type='StackingColumn'
                          fill={el.color}
                          cornerRadius={{
                            topLeft: 0,
                            topRight: 0,
                          }}
                        ></SeriesDirective>
                      );
                    }
                  })}
                </SeriesCollectionDirective>
              </ChartComponent>
            </div>
            <div className='chart3' style={{ width: '33%' }}>
              <div>
                <span>
                  <b># of Hours by Tradesperson</b>
                </span>
              </div>
              <div>
                <ChartComponent
                  id='assigncharts3'
                  style={{ textAlign: 'center' }}
                  ref={(el) => {
                    this.grap3Obj = el as ChartComponent;
                  }}
                  primaryXAxis={{
                    majorGridLines: { width: 0 },
                    minorGridLines: { width: 0 },
                    majorTickLines: { width: 0 },
                    minorTickLines: { width: 0 },
                    interval: 1,
                    lineStyle: { width: 0 },
                    labelIntersectAction: 'Rotate45',
                    valueType: 'Category',
                    labelStyle: {
                      size: '0px',
                    },
                  }}
                  primaryYAxis={{
                    lineStyle: { width: 0 },
                    majorTickLines: { width: 1 },
                    majorGridLines: { width: 0 },
                    minorGridLines: { width: 1 },
                    minorTickLines: { width: 1 },
                    labelFormat: '{value}',
                    labelStyle: {
                      size: '8px',
                    },
                  }}
                  width={'100%'}
                  chartArea={{ border: { width: 0 } }}
                  tooltip={{ enable: true }}
                  height={'190px'}
                  background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
                  legendSettings={{
                    textStyle: {
                      color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                      size: '8px',
                    },
                    position: 'Top',
                  }}
                >
                  <Inject
                    services={[StackingColumnSeries, Category, Legend, Tooltip]}
                  />
                  <SeriesCollectionDirective>
                    {this.graph3Tickets.map((el: any, index: number) => {
                      return (
                        <SeriesDirective
                          key={Math.random()}
                          dataSource={this.state.graph3Data}
                          xName='assignmentName'
                          yName={`y${index}`}
                          name={el.value}
                          type='StackingColumn'
                          fill={el.color}
                        ></SeriesDirective>
                      );
                    })}
                  </SeriesCollectionDirective>
                </ChartComponent>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = (state: RootState) => ({
  defaultAssignments: state.search.defaultAssignments,
  largeMode: state.search.largeMode,
  storeTeam: state.search.storeTeam,
  storeTrades: state.search.storeTrades,
  storeAssign: state.search.storeAssign,
  storeTradeAssignmentIds: state.search.storeTradeAssignmentIds,
  filterConfirmation: state.search.filterConfirmation,
});

const mapDispatchToProps = (dispatch: any) => ({
  setfilterConfirmation: (value: boolean) =>
    dispatch(setfilterConfirmation(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TradepersonCapacity);
